import Layout from 'antd/lib/layout';
import type { LayoutProps } from 'antd/lib/layout';
import type { SiderProps } from 'antd/lib/layout/Sider';

// Exportamos los tipos necesarios
export type DLayoutProps = LayoutProps;
export type DSiderProps = SiderProps;

// Creamos el componente principal y sus subcomponentes
export const DarwinLayout = Object.assign(
  // Componente principal
  (props: DLayoutProps) => <Layout {...props} />,
  {
    // Subcomponentes
    Header: Layout.Header,
    Footer: Layout.Footer,
    Content: Layout.Content,
    Sider: Layout.Sider,
    _InternalSiderContext: Layout._InternalSiderContext,
  }
);

// Exportaciones individuales de los subcomponentes si se necesitan
export const DarwinHeader = Layout.Header;
export const DarwinFooter = Layout.Footer;
export const DarwinContent = Layout.Content;
export const DarwinSider = Layout.Sider;
